// src/version.ts
var VERSION_REG = /^([a-zA-Z0-9_\d]+)\/([a-zA-Z0-9_\d]+)$/;
function isValidVersion(v) {
  return VERSION_REG.test(v);
}
function parseVersion(v) {
  if (!isValidVersion(v)) {
    throw new Error(`Invalid version string: "${v}"`);
  }
  const [, category, value] = v.match(VERSION_REG) || [];
  return {
    category,
    value
  };
}

// src/component.ts
function createComponent(options) {
  return {
    ...options,
    kind: "Component",
    parsedVersion: parseVersion(options.version)
  };
}

// src/trait.ts
function createTrait(options) {
  return {
    version: options.version,
    kind: "Trait",
    parsedVersion: parseVersion(options.version),
    metadata: {
      ...options.metadata,
      description: options.metadata.description || "",
      annotations: options.metadata.annotations || {}
    },
    spec: {
      properties: {},
      state: {},
      methods: [],
      ...options.spec
    }
  };
}

// src/scope.ts
function createScope(options) {
  return {
    ...options,
    kind: "Scope",
    parsedVersion: parseVersion(options.version)
  };
}

// src/application.ts
var TYPE_REG = /^([a-zA-Z0-9_\d]+\/[a-zA-Z0-9_\d]+)\/([a-zA-Z0-9_\d]+)$/;
function isValidType(v) {
  return TYPE_REG.test(v);
}
function parseType(v) {
  if (!isValidType(v)) {
    throw new Error(`Invalid type string: "${v}"`);
  }
  const [, version, name] = v.match(TYPE_REG) ?? [];
  return {
    version,
    name
  };
}
function isValidId(id) {
  return /^[a-zA-Z_$][0-9a-zA-Z_$]+$/.test(id);
}
function createApplication(options) {
  return {
    ...options,
    kind: "Application",
    parsedVersion: parseVersion(options.version),
    spec: {
      ...options.spec,
      components: options.spec.components.map((c) => {
        if (!isValidId(c.id)) {
          throw new Error(`Invalid id: "${c.id}"`);
        }
        return {
          ...c,
          parsedType: parseType(c.type),
          traits: c.traits.map((t) => {
            return {
              ...t,
              parsedType: parseType(t.type)
            };
          })
        };
      })
    }
  };
}

// src/module.ts
function createModule(options) {
  return {
    version: options.version,
    kind: "Module",
    parsedVersion: parseVersion(options.version),
    metadata: {
      name: options.metadata.name,
      description: options.metadata.description || "",
      exampleProperties: options.metadata.exampleProperties || {}
    },
    spec: {
      properties: { type: "object" },
      events: [],
      stateMap: {},
      methods: [],
      ...options.spec
    },
    impl: options.impl || []
  };
}

// src/utilMethod.ts
function createUtilMethod(options) {
  return {
    ...options,
    kind: "UtilMethod",
    parsedVersion: parseVersion(options.version)
  };
}
export {
  createApplication,
  createComponent,
  createModule,
  createScope,
  createTrait,
  createUtilMethod,
  isValidId,
  isValidVersion,
  parseType,
  parseVersion
};
